module.exports = __webpack_public_path__ + "static/media/service10.7887a01e.jpg";